import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleHeart"><Path d="M21.002 19.0361H15.376L11.9941 21.8379L8.65137 19.0361H3.00195V3H21.002V19.0361ZM15.251 10.668C15.251 8.91991 13.5027 7.87839 11.999 8.84961C10.4954 7.87889 8.74805 8.92008 8.74805 10.668C8.74836 12.988 11.9653 14.2669 11.999 14.2803C11.999 14.2803 15.2507 13.0002 15.251 10.668Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleHeart;
